import { jsPDF } from 'jspdf';

import { formatDate } from '~/utils/date';

import { LABEL_LAYOUT } from './labelLayoutConfig';
import { drawFullLabel } from './labelSections';
import { loadKoreanFont } from './loadKoreanFont';

import type { TypeReceivingLabelLabel } from '~/types/receive.types';

/**
 * 입고 라벨 PDF 생성 및 다운로드
 *
 * @param labels 라벨 데이터 배열
 */
export const generateReceiveLabelPDF = async (labels: TypeReceivingLabelLabel[]) => {
  if (labels.length === 0) {
    throw new Error('라벨 데이터가 없습니다.');
  }

  // PDF 생성 (100mm x 100mm 라벨)
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [110, 110],
  });

  // 한글 폰트 로드 및 설정
  await loadKoreanFont(pdf);
  pdf.setFont('NanumGothic', 'normal');

  // 페이지 생성
  for (let i = 0; i < labels.length; i++) {
    if (i > 0) {
      pdf.addPage();
    }
    await drawFullLabel(pdf, labels[i], LABEL_LAYOUT.page.margin);
  }

  // PDF 다운로드
  const fileName = `입하_라벨_${formatDate(new Date(), 'YYYYMMDD_HHmmss') ?? ''}.pdf`;
  pdf.save(fileName);
};
